<template>
    <div class="top-tags">
        <div class="tags-body">
            <p><a href="#" @click="this.$router.push('/')">首页</a> > <a href="#" @click="this.$router.push('/Appreciation')">钱币赏析</a></p>
        </div>
    </div>
    <div class="zhu-appreciation">
        <h3>钱币赏析</h3>
        <div class="appreciation-body">
            <!-- ---------------------------------------------------金币 11111 -->
            <div class="body-div">
                <el-image
                    style="width: 263px; height: 350px"
                    :src="url"
                    :preview-src-list="srcList"
                    :initial-index="0"
                    fit="cover"
                    >
                </el-image>
                <p>嘉庆通宝文庆背上星</p>
            </div>
            <div class="body-div">
                <el-image
                    style="width: 263px; height: 350px"
                    :src="url2"
                    :preview-src-list="srcList"
                    :initial-index="1"
                    fit="cover"
                    >
                </el-image>
                <p>法属印支银币壹圆</p>
            </div>
            <div class="body-div">
                <el-image
                    style="width: 263px; height: 350px"
                    :src="url3"
                    :preview-src-list="srcList"
                    :initial-index="2"
                    fit="cover"
                    >
                </el-image>
                <p>袁世凯像壹圆（民国三年）</p>
            </div>
            <div class="body-div">
                <el-image
                    style="width: 263px; height: 350px"
                    :src="url4"
                    :preview-src-list="srcList"
                    :initial-index="3"
                    fit="cover"
                    >
                </el-image>
                <p>云南省造半圆双旗</p>
            </div>
            <div class="body-div">
                <el-image
                    style="width: 263px; height: 350px"
                    :src="url5"
                    :preview-src-list="srcList"
                    :initial-index="4"
                    fit="cover"
                    >
                </el-image>
                <p>法属印支银币</p>
            </div>
            <!-- ---------------------------------------------------金币 66666 -->
            <div class="body-div">
                <el-image
                    style="width: 263px; height: 350px"
                    :src="url6"
                    :preview-src-list="srcList"
                    :initial-index="5"
                    fit="cover"
                    >
                </el-image>
                <p>袁世凯像贰角（民国三年）</p>
            </div>
            <div class="body-div">
                <el-image
                    style="width: 263px; height: 350px"
                    :src="url7"
                    :preview-src-list="srcList"
                    :initial-index="6"
                    fit="cover"
                    >
                </el-image>
                <p>福建民国甲子银币</p>
            </div>
            <div class="body-div">
                <el-image
                    style="width: 263px; height: 350px"
                    :src="url8"
                    :preview-src-list="srcList"
                    :initial-index="7"
                    fit="cover"
                    >
                </el-image>
                <p>孙像伍角银币</p>
            </div>
            <div class="body-div">
                <el-image
                    style="width: 263px; height: 350px"
                    :src="url9"
                    :preview-src-list="srcList"
                    :initial-index="8"
                    fit="cover"
                    >
                </el-image>
                <p>法属印支银币</p>
            </div>
            <div class="body-div">
                <el-image
                    style="width: 263px; height: 350px"
                    :src="url10"
                    :preview-src-list="srcList"
                    :initial-index="9"
                    fit="cover"
                    >
                </el-image>
                <p>蒙古银币</p>
            </div>
            <!-- ---------------------------------------------------金币 11-11-11-11 -->
            <div class="body-div">
                <el-image
                    style="width: 263px; height: 350px"
                    :src="url11"
                    :preview-src-list="srcList"
                    :initial-index="10"
                    fit="cover"
                    >
                </el-image>
                <p>蒙古银币</p>
            </div>
			<div class="body-div">
			    <el-image
			        style="width: 263px; height: 350px"
			        :src="url12"
			        :preview-src-list="srcList"
			        :initial-index="11"
			        fit="cover"
			        >
			    </el-image>
			    <p>云南省造半圆龙（三回珠）</p>
			</div>
            
        </div>

    </div>
</template>

<script>
export default {
    data () {
        return {
            url: require('../assets/img/reference/1.jpg'),
            url2: require('../assets/img/reference/2.jpg'),
            url3: require('../assets/img/reference/3.jpg'),
            url4: require('../assets/img/reference/4.jpg'),
            url5: require('../assets/img/reference/5.jpg'),
            url6: require('../assets/img/reference/6.jpg'),
            url7: require('../assets/img/reference/7.jpg'),
            url8: require('../assets/img/reference/8.jpg'),
            url9: require('../assets/img/reference/9.jpg'),
            url10: require('../assets/img/reference/10.jpg'),
            url11: require('../assets/img/reference/11.jpg'),
            url12: require('../assets/img/reference/12.jpg'),
            //轮播图
            srcList : [
                require('../assets/img/reference/1.jpg'),
                require('../assets/img/reference/2.jpg'),
                require('../assets/img/reference/3.jpg'),
                require('../assets/img/reference/4.jpg'),
                require('../assets/img/reference/5.jpg'),
                require('../assets/img/reference/6.jpg'),
                require('../assets/img/reference/7.jpg'),
                require('../assets/img/reference/8.jpg'),
                require('../assets/img/reference/9.jpg'),
                require('../assets/img/reference/10.jpg'),
                require('../assets/img/reference/11.jpg'),
				require('../assets/img/reference/12.jpg'),
            ],
        }
    }
}
</script>

<style lang="scss" scoped>
//-------------------------------小跳转菜单
.top-tags {
    width: 100%;
    height: 40px;
    background: #f3f3f3;
    .tags-body {
        width: 1210px;
        margin: 0 auto;
        border: 1px solid #f3f3f3;
        text-align: left;
        position: relative;
        @media only screen and (max-width: 1210px) {
            width: 100%;
        }
        
        p {
            margin-top: 10px;
            padding-left: 5px;
            border-left: 6px solid #409EFF;
            
            a {
                color: #303133;
                font-size: 14px;
                text-decoration: none;
                &:hover {
                    color: #409EFF;
                }
            }
        }
    }
}


.zhu-appreciation {
    width: 1400px;
    margin: 0 auto;
    @media only screen and (max-width: 1400px) {
        width: 100%;
    }
    h3 {
        @media only screen and (max-width: 615px) {
            text-align: center;
            border: 0;
        }
        font-size: 24px;
        text-align: left;
        margin: 20px 96px;
        padding: 10px 0;
        border-bottom: 1px solid #DFDFDF;
        position: relative;
        &::after {
            content: "";
            position: absolute;
            left: 48px;
            bottom: -1px;
            width: 100px;
            height: 2px;
            margin-left: -50px;
            background-color: #409EFF;
            @media only screen and (max-width: 615px) {
                left: 50%;
            }
        }
    }

    .appreciation-body {
        width: 1210px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        @media only screen and (max-width: 1210px) {
            width: 100%;
        }
        .body-div {
            @media only screen and (max-width: 615px) {
                margin: 0 auto ;
                margin-bottom: 30px;
            }
            border: 1px solid #99a9bf;
            width: 263px;
            margin: 10px 10px 30px 25px;
            el-image {
                width: 263px;
            }
            p {
                line-height: 40px;
            }

            &:hover {
                border: 1px solid #E22434;
                cursor: default;
            }
        }
    }

}

</style>